export default __webpack_public_path__ + "static/media/flow1_3.a7ca640c.jpg";